import { OktaAuthService } from '@okta/okta-angular';
import { Observable, from } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { environment } from 'src/environments/environment';
import { finalize } from 'rxjs/operators';
import { loadavg } from 'os';
import { promise } from 'protractor';

export const OKTA_ROUTES: string[] = [
  environment.apiURLRC,
  environment.apiURLROCT,
];

@Injectable({
  providedIn: 'root'
})

export class HttpAccessInterceptor implements HttpInterceptor {

  constructor(private okta: OktaAuthService) { }

  private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {

    const shouldAuthenticate = OKTA_ROUTES.map(route => request.url.includes(route)).includes(true);
    LoaderService.showLoader();
    const accessToken = await this.okta.getAccessToken();
    localStorage.setItem('token', accessToken);

    request = shouldAuthenticate ?
      request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + accessToken
        }
      }) : request;

    return next.handle(request).pipe(
      finalize(() => LoaderService.hideLoader())).toPromise();
    // return next.handle(request).toPromise();
  }

// http interceptor to handle all the HTTP requestes and responses.
intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }
}
